import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "defecation-status-text" }
const _hoisted_3 = { class: "defecation-modal-time-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_time_picker = _resolveComponent("v-time-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, {
    class: _normalizeClass(['py-3', { 'en-card-text-padding': _ctx.$i18n.locale === 'en' }])
  }, {
    default: _withCtx(() => [
      (_ctx.defecationTemp)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['d-flex align-center justify-center mb-5 before-correction-row', { 'flex-wrap': _ctx.$i18n.locale === 'en' }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['before-correction-label', { 'text-no-wrap': _ctx.$i18n.locale === 'en' }])
            }, _toDisplayString(_ctx.$t('defecationModal.beforeCorrection')), 3),
            _createVNode(_component_v_chip, {
              color: "defecation",
              class: "chip-auto-width defecation-label-chip",
              variant: "outlined",
              size: "x-small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('defecationModal.defecationLabel')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.formatTime(_ctx.defecationTemp.recordedAt)), 1),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.showDefecationStatus(_ctx.defecationTemp.state)), 1)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_menu, {
          modelValue: _ctx.isRecordetAtPicker,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isRecordetAtPicker) = $event)),
          "close-on-content-click": false,
          location: "bottom start",
          transition: "scale-transition",
          "min-width": "290px",
          "max-width": "290px"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_text_field, _mergeProps({
              "model-value": _ctx.localRecordedAt,
              label: _ctx.$t('defecationModal.timeLabel'),
              "prepend-icon": "mdi-clock-time-four-outline",
              rules: [_ctx.rules.required],
              readonly: ""
            }, props, {
              variant: "outlined",
              density: "compact",
              color: "primary"
            }), null, 16, ["model-value", "label", "rules"])
          ]),
          default: _withCtx(() => [
            (_ctx.isRecordetAtPicker)
              ? (_openBlock(), _createBlock(_component_v_time_picker, {
                  key: 0,
                  modelValue: _ctx.localRecordedAt,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localRecordedAt) = $event)),
                    _ctx.onTimePicked
                  ],
                  format: "24hr",
                  locale: "ja",
                  "allowed-minutes": _ctx.allowedStep,
                  color: "primary",
                  onKeydownCapture: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                }, null, 8, ["modelValue", "allowed-minutes", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_v_select, {
        "model-value": _ctx.state,
        "onUpdate:modelValue": _ctx.onChangeState,
        items: _ctx.choices,
        "item-title": "text",
        "item-value": "value",
        rules: [_ctx.rules.required],
        label: _ctx.$t('defecationModal.stateLabel'),
        variant: "outlined",
        density: "compact"
      }, null, 8, ["model-value", "onUpdate:modelValue", "items", "rules", "label"])
    ]),
    _: 1
  }, 8, ["class"]))
}